import { Component, OnInit, ViewChild } from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService, BsModalRef} from "ngx-bootstrap";

@Component({
  selector: 'app-packages',
  templateUrl: './packages.component.html',
  styleUrls: ['./packages.component.scss']
})
export class PackagesComponent implements OnInit {
  isLoading: any;
  packForm: any;
  packages: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  deleteID: any;
  page: any;
  totalRec: any;
  currentPage: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.getallPackages(1);
  }


  getallPackages(pageIndex){
    let req ={}
    let size = 10;
    let page = pageIndex - 1;
    this.userService.packageSearch(req,size,page).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.packages =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  packageDelete(errorModal, id: any) {
    this.deleteID = id;
    this.modalRef = this.modalService.show(errorModal, {class: 'modal-dialog-centered'});
  }

  packageUpdate(id: any) {

  }

  createModal() {

  }

  createPackage() {

  }

  declineDelete() {
    this.modalRef.hide();
  }


  confirmDelete() {
    this.userService.deletePackage(this.deleteID).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.modalRef.hide();
          this.notifier.notify('success', res.responseDesc);
          this.getallPackages(this.currentPage);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  update(pac: any) {
    localStorage.setItem('packUpdate','true');
    localStorage.setItem('packUpdateData',JSON.stringify(pac));
    this.route.navigate(['/create-package']);
  }
}
